import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useAiDictationStore from '../stores/aiDictationStore';
import StatusBar from '../components/StatusBar';

const AiDictationManual = () => {
  const navigate = useNavigate();
  const { selectedWords, addWord, removeWord, setSourceType } = useAiDictationStore();
  const [newWord, setNewWord] = useState('');
  
  // 设置来源类型
  React.useEffect(() => {
    setSourceType('manual');
  }, [setSourceType]);

  // 处理添加单词
  const handleAddWord = () => {
    if (newWord.trim()) {
      addWord(newWord.trim());
      setNewWord('');
    }
  };

  // 处理输入框按键事件
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAddWord();
    }
  };

  return (
    <div className="min-h-screen bg-[#f9f9f9] text-[#333]">
      {/* iOS Status Bar */}
      <StatusBar />

      {/* Main Content */}
      <div className="p-5 pb-24">
        {/* Navigation Header */}
        <div className="flex justify-between items-center mb-6">
          <Link to="/ai-dictation" className="text-blue-500">
            <i className="fa-solid fa-chevron-left mr-1"></i>
            返回
          </Link>
          <h2 className="text-xl font-bold">手动选择单词</h2>
          <div className="w-16"></div> {/* Spacer for alignment */}
        </div>

        {/* Word Input */}
        <div className="mb-6">
          <h3 className="font-bold text-lg mb-3">添加单词</h3>
          <div className="bg-white rounded-xl p-4 shadow-sm">
            <div className="flex mb-4">
              <input
                type="text"
                value={newWord}
                onChange={(e) => setNewWord(e.target.value)}
                onKeyPress={handleKeyPress}
                className="flex-1 p-3 border border-gray-300 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="输入单词"
              />
              <button
                onClick={handleAddWord}
                className="bg-indigo-600 text-white px-4 rounded-r-lg"
              >
                添加
              </button>
            </div>
            <p className="text-xs text-gray-500">
              <i className="fa-solid fa-circle-info mr-1"></i>
              添加您想要包含在AI生成短文中的单词
            </p>
          </div>
        </div>

        {/* Selected Words */}
        <div className="mb-6">
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-bold text-lg">已选单词</h3>
            <div className="text-indigo-600 text-sm font-medium">
              {selectedWords.length} / 10
            </div>
          </div>
          <div className="bg-white rounded-xl p-4 shadow-sm">
            {selectedWords.length > 0 ? (
              <div className="flex flex-wrap gap-2">
                {selectedWords.map((word) => (
                  <div 
                    key={word.id}
                    className="word-chip px-3 py-2 rounded-full text-sm border border-indigo-300 bg-indigo-50 text-indigo-700 flex items-center"
                  >
                    <span>{word.word}</span>
                    <button 
                      className="ml-1 text-indigo-400"
                      onClick={() => removeWord(word.id)}
                    >
                      <i className="fa-solid fa-xmark text-xs"></i>
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-4 text-gray-500">
                还没有添加单词
              </div>
            )}
          </div>
        </div>

        {/* Common Words Suggestions */}
        <div className="mb-8">
          <h3 className="font-bold text-lg mb-3">常用单词推荐</h3>
          <div className="bg-white rounded-xl p-4 shadow-sm">
            <div className="flex flex-wrap gap-2">
              {['book', 'pen', 'school', 'teacher', 'student', 'friend', 'family', 'house', 'car', 'dog', 'cat'].map((word, index) => (
                <div 
                  key={index}
                  className="word-chip px-3 py-2 rounded-full text-sm border border-gray-300 bg-gray-50 text-gray-700 cursor-pointer hover:bg-gray-100"
                  onClick={() => {
                    addWord(word);
                  }}
                >
                  {word}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Continue Button */}
        <button 
          className="w-full bg-indigo-600 text-white py-4 rounded-xl font-bold text-lg shadow-md flex items-center justify-center"
          onClick={() => navigate('/ai-dictation')}
          disabled={selectedWords.length === 0}
        >
          <i className="fa-solid fa-check mr-2"></i>
          确认选择
        </button>
      </div>
    </div>
  );
};

export default AiDictationManual;